module.exports = __webpack_public_path__ + "img/logo_light.c0c7c412.png";